<template>
	<div v-if="show" :class="{ 'backdrop-flex-start': size === 'xl'}">
		<div
			class="modal-backdrop"
			ref="backdrop"
			@click.self="hideModal"
		></div>
		<div
			:class="[
				'modal',
				`modal-${size}`
			]"
			ref="modal-content"
		>
			<div class="scroll-wrap">
				<div class="modal-header">
					<h2>{{title}}</h2>
					<VButtonClose v-if="isSmallScreen" class="close-modal-btn" @clickHandler="hideModal" />
				</div>
				<div class="modal-body">
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VButtonClose from "@/components/atoms/VButtonClose.vue";

export default {
	name: 'VModal',
	components: {
		VButtonClose
	},
	props: {
		size: {
			default: 'md'
		},
		title: {},
		name: {}
	},
	data() {
		return {
			show: false,
			isSmallScreen: window.innerWidth <= 768,
		}
	},
	mounted() {
		window.addEventListener('resize', this.checkScreenWidth);
	},
	methods: {
		showModal(firstInputFocus = 'input') {
			this.show = true;
			this.$nextTick(() => {
				if (document.querySelector('.edit-task-modal') && document.querySelectorAll('.edit-task-modal .modal').length > 1) {
					this.$refs.backdrop.style.top = document.querySelector('.edit-task-modal .modal').scrollTop + 'px'
					this.$refs['modal-content'].style.marginTop = document.querySelector('.edit-task-modal .modal').scrollTop + 'px'
					document.querySelector('.edit-task-modal .modal').style.overflowY = 'hidden'
				}
			})

			setTimeout(() => {
				if(document.querySelector('.billing-modal')) return
				
                var firstInput = this.$el && this.$el.querySelector(firstInputFocus);
                if(firstInput && firstInput.getAttribute('placeholder') && firstInput.getAttribute('placeholder').includes('Add a task name...')) return

				if (firstInput) firstInput.focus();
            }, 10);
		},
		hideModalHandler(e) {
			if(e.target.classList.contains('modal-backdrop')) {
				this.hideModal(e)
			}
		},
		hideModal(e) {
			if((this.isTaskEditing || this.isCommenting) && this.$el.classList.contains('edit-task-modal')) {
				this.$emit('hiddenCancel')
				return
			}

			if(this.$el?.classList?.contains('preview-screencast-video') && e?.target?.classList?.contains('modal-backdrop')) {
				this.$emit('hiddenCancel')
				return
			}

			this.$nextTick(() => {
				if(document.querySelector('.edit-task-modal .modal')) {
					document.querySelector('.edit-task-modal .modal').style.overflowY = 'auto'
				}
			})

			setTimeout(() => {
				this.show = false;
				this.$emit('hideModal')
			}, 10)
		},
		checkScreenWidth() {
			this.isSmallScreen = window.innerWidth <= 768;
		},
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.checkScreenWidth);
	},
	computed: {
		isTaskEditing() {
			return this.$store.getters.isTaskEditing
		},
		isCommenting() {
			return this.$store.getters.isCommenting
		}
	}
}
</script>

<style scoped lang="scss">
.modal-backdrop {
	position: fixed;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	z-index: 10;
	background: rgba($gray-0, .5);
	display: flex;
	align-items: center;
	justify-content: center;
	&.backdrop-flex-start {
		display: flex;
		align-items: flex-start;
		justify-content: center;
		padding-top: 30px;
	}
}

.modal {
	border-radius: $border-radius-base;
	width: 95%;
	max-width: 700px;
	backdrop-filter: blur(6px);
	padding: 10px 34px 24px;
	z-index: 99;
	background-color: var(--primary-bg);
	height: auto;
	max-height: 90%;
	overflow-y: auto;
	overflow-x: hidden;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);

	&.modal-sm {
		max-width: 350px;
		border-radius: 10px;
	}

	&.modal-md {
		max-width: 550px;
		border-radius: 10px;
	}

	&.modal-lg {
		max-width: 1000px;
	}

	&.modal-xl {
		max-width: 1400px;
	}

	&.modal-xl-pd-10 {
		max-width: 1400px;
		padding: 0 10px 10px;
	}

	&.modal-xxl {
		max-width: calc(100% - 30px);
	}

	.scroll-wrap {
		//overflow: auto;
		height: 100%;
	}

	.modal-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 0;

		.close-modal-btn {
			position: absolute;
			top: 8px;
		right: 16px;
			z-index: 99;
			//transform: translate(-22%, 28%);
		}
	}

	.modal-body {
		//padding: 0 20px 20px 20px;
		height: calc(100% - 77px);
	}
}

.edit-task-modal > .modal {
	background-color: var(--primary-bg);
	max-height: 95%;

	& > .scroll-wrap > .modal-header {
		margin-bottom: 8px;
	}
}

.preview-screencast-video {
	.modal {
			padding: 0 9px 0 !important;
	}
}
</style>
